export const STORAGE_KEYS = {
  FILTER_PRESETS: 'chickpeace-filter-presets'
} as const;

export const MAX_NESTING_DEPTH = 3;
